import React from 'react';

function Bird({ yPosition, xPosition = 100, flap = false, rotation = 0, customBird = null }) {
  return (
    <div style={{
      position: 'absolute',
      top: `${yPosition}px`,
      left: `${xPosition}px`,
      width: '40px',
      height: '30px',
      backgroundColor: customBird ? 'transparent' : 'yellow',
      borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
      transform: `rotate(${rotation}deg)`,
      zIndex: 5,
      transition: 'transform 0.2s ease-out',
      margin: 'auto' // Helps with centering if needed
    }}>
      {customBird ? (
        <img
          src={customBird}
          alt="Custom Bird"
          style={{
            width: '40px',
            height: '30px',
            objectFit: 'fill',
            borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
            pointerEvents: 'none'
          }}
        />
      ) : (
        <>
          {/* Beak */}
          <div style={{
            position: 'absolute',
            right: '-8px',
            top: '8px',
            width: '12px',
            height: '8px',
            backgroundColor: 'orange',
            borderRadius: '50% 50% 0 50%',
            transform: 'rotate(-30deg)'
          }} />
          {/* Eye */}
          <div style={{
            position: 'absolute',
            right: '6px',
            top: '6px',
            width: '8px',
            height: '8px',
            backgroundColor: 'black',
            borderRadius: '50%'
          }} />
          {/* Feather */}
          <div style={{
            position: 'absolute',
            left: '35%',
            top: '55%',
            width: '25px', // Adjust as needed
            height: '7px', // Adjust as needed
            backgroundColor: 'orange',
            borderRadius: '50% 50% 50% 50%', // Top rounded, bottom pointy but still slightly rounded
            clipPath: 'polygon(0 0, 100% 0, 30% 100%, 25% 100%)', // Trapezoid shape, but with rounded top
            transform: flap
              ? 'translateX(-50%) scaleY(1.9)'
              : 'translateX(-50%) scaleY(1)',
            transformOrigin: 'top center',
            //transition: 'transform 0.05s cubic-bezier(.4,2,.6,1)',
            zIndex: 6
          }} />
        </>
      )}
    </div>
  );
}

export default React.memo(Bird);